export default __webpack_public_path__ + "static/media/1.1342cc30.png";